import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import CategoryApi from '../../../../lib/api/category/CategoryApi';
import { CATEGORY } from '../../../../constants/queryKeys';
import { CATEGORY_HISTORY_REQUEST_PARAM } from '../constants';
import { setDash } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { ICategoryHistoryResponse } from '../types';
import { UseQueryResult } from '@tanstack/react-query/src/types';

interface IUseCategoryHistoryProps {
  type: 'first' | 'last';
}
/**
 * 카테고리 수정 이력 리스트를 가져오는 query hook
 */
const useCategoryHistory = ({ type }: IUseCategoryHistoryProps): UseQueryResult<ICategoryHistoryResponse> => {
  const { id } = useParams<{ id: string }>();
  return useQuery(
    [...CATEGORY.HISTORY_LIST, id, type],
    () => CategoryApi.getCategoryHistoryList(Number(id), CATEGORY_HISTORY_REQUEST_PARAM[type]),
    {
      select: (result) => ({
        name: setDash(result?.histories[0].admin?.name),
        date: setDateFormat(result?.histories[0].createDate, DATE_FORMAT.FULL_DASH_FORMAT),
      }),
    },
  );
};

export default useCategoryHistory;
